export enum URLParamEnum {
  Filters = "filters",
}
